// extracted by mini-css-extract-plugin
export var borderTop = "_j-3";
export var linkIcon = "_j-5";
export var linkIconSm = "_j-6";
export var linkOutCard = "_j-7 _j-4";
export var linkRow = "_j-2";
export var pageContainer = "_j-1";
export var providerIcon = "_j-8";
export var roundedBorder = "_j-4";
export var settingsContent = "_j-0";